import styled from 'styled-components';
import getBaseStyleFormField from './baseStyleFormField';

const BaseStyledTextarea =styled(getBaseStyleFormField('textarea'))`
 height: auto;
`;

export default BaseStyledTextarea;
